import type { ReactNode } from "react";
import { useRef } from "react";

import { StyledIgnoredWrapper } from "app/pages/sales-intelligence/common-components/styles";

import { useCloseOnScroll } from "./useCloseOnScroll";

type ScrollDismissBoundaryProps = {
    isOpen: boolean;
    onClose: VoidFunction;
    children: ReactNode;
};

/**
 * Wraps a popover/combobox so it closes when an ancestor scroll container scrolls. The wrapper renders a
 * zero-layout anchor inside the trigger's subtree (NOT the portaled popover), which the scroll-dismiss
 * registry uses to decide — by DOM containment — whether a given scroll should close this popover.
 */
export const ScrollDismissBoundary = ({ isOpen, onClose, children }: ScrollDismissBoundaryProps) => {
    const anchorRef = useRef<HTMLDivElement>(null);

    useCloseOnScroll(isOpen, onClose, anchorRef);

    return <StyledIgnoredWrapper ref={anchorRef}>{children}</StyledIgnoredWrapper>;
};
